<template>
	<v-menu
      v-model="menuOpen"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="formattedDate(type)"
            :label="label"
            :prepend-icon="icon" 
            v-on="on"
            :rounded="rounded" 
            :dense="dense" 
            :filled="filled" 
            v-on:click:prepend="menuOpen=true"
          ></v-text-field>
        </template>
        <v-date-picker 
        v-on:change="save"
        v-if="type=='date'" 
        v-model="value"  >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menuOpen = false">Cancel</v-btn>
        <v-btn text color="primary" @click="save(value); menuOpen = false;">OK</v-btn>

        </v-date-picker>
        <v-time-picker 
        format="24hr"
        v-if="type=='time'" 
        v-on:change="save"
        v-model="value"  >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menuOpen = false">Cancel</v-btn>
        <v-btn text color="primary" @click="save(value); menuOpen = false;">OK</v-btn>

        </v-time-picker>
      </v-menu>
</template>


<script>
import Vue from "vue";


export default {
  name: 'DateTimeField',
  props: {
    "object": { type: Object }, 
    "type": {type: String, default: 'date'}, 
    "initialValue": {type: String},
    "label": {type: String},
    "objectKey": {type: String},
    rounded: {type: Boolean},
    filled: {type: Boolean},
    dense: {type: Boolean}
  },
  data: () => {
    return { 
      value: '',
      menuOpen: 0
    }
  },
  computed: {
    icon: function(){
      if( this.type == 'time'){ return 'mdi-clock'; }
      else{ return 'mdi-calendar'; }
    }
  },
  methods: {
    formattedDate(){
      if( !this.value ){
        return '';
      }
      if( this.type == 'time'){ 
        return this.value;
      }
      else{
        return Vue.moment(this.value).format('DD/MM/YYYY');
      }
    },
    save: function(value){
      if( value !== this.object[this.objectKey] ){ 
        this.object[this.objectKey] = value;
        this.$emit("updated", this.object, this.objectKey)
      }    
    }
  },
  watch:{
    initialValue(value){
      this.value = value;
    }
  },
  created: function(){
    this.value = this.object[this.objectKey]
  }
};
</script>
